export default __webpack_public_path__ + "media/images/lp/img3-29971f774aa43884f0f7eaba6ae992ca.png";